import { BASE_URL, post, useFetch } from 'utils/sdk';

export interface LoginResponse {
  token: string;
  user: {
    email: string;
  };
}
export const login = ({
  email,
  password
}: {
  email: string;
  password: string;
}): Promise<LoginResponse> =>
  post(`${BASE_URL}/api/v1/auth/research-portal/login/`, { email, password });

export const logout = () => post(`${BASE_URL}/api/v1/auth/logout/`);

export interface MeResponse {
  id: number;
  is_data_researcher: boolean;
  currency: string;
}
export const useMe = () => useFetch<MeResponse>(`/api/v1/auth/me/`);

export interface ResetPasswordResponse {
  user: {
    email: string;
  };
}

export const resetPassword = ({
  password,
  confirm_password,
  token
}: {
  password: string;
  confirm_password: string;
  token: string;
}): Promise<ResetPasswordResponse> =>
  post(`${BASE_URL}/api/v1/auth/research-portal/password-reset/`, {
    password,
    confirm_password,
    token
  });
